module.exports = __webpack_public_path__ + "img/baizhi-back-two@2x.c81cfe2b.png";